'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIRST_COLOR = exports.FIRST_COLOR = '#425b76';
var SECOND_COLOR = exports.SECOND_COLOR = '#00a4bd';
var THIRD_COLOR = exports.THIRD_COLOR = '#b24592';
var FOURTH_COLOR = exports.FOURTH_COLOR = '#ff5f6d';
var FIFTH_COLOR = exports.FIFTH_COLOR = '#3788d1';
var DEFAULT_CUSTOM_COLOR = exports.DEFAULT_CUSTOM_COLOR = '#3288e6';

var STATIC_COLORS = exports.STATIC_COLORS = [FIRST_COLOR, SECOND_COLOR, THIRD_COLOR, FOURTH_COLOR, FIFTH_COLOR];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/BaseBrandColors.js
// module id = 929
// module chunks = 2 3